import React from 'react';

const IconChevronLeft = () => {
    return (
        <svg className="icon-svg" style={{height: 24, width: 24}} preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100">
            <g>
                <polygon points="67.68 71.21 46.46 50 67.68 28.79 60.61 21.72 32.32 50 60.61 78.28 67.68 71.21" />
            </g>
        </svg>
    )
};

export default IconChevronLeft;



// WEBPACK FOOTER //
// ./src/icons/icon-chevron-left.js